import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../Layout/Layout";
import ProtectedRoute from "../../components/ProtectedRoute";
import { BarLoader } from "react-spinners";

// Admin Components
const AdminLayout = lazy(() => import("../Admin/AdminLayout"));
const AdminDashboard = lazy(() => import("../../pages/Admin/AdminDashboard"));
const ProhibitedWordsManagement = lazy(
  () => import("../../pages/Admin/ProhibitedWordsManagement"),
);
const ManualApprovalSettings = lazy(
  () => import("../../pages/Admin/ManualApprovalSettings"),
);
const ContestApprovalSettings = lazy(
  () => import("../../pages/Admin/ContestApprovalSettings"),
);
const ModerationPage = lazy(() => import("../../pages/Admin/ModerationPage"));

// Lazy load all the pages
const Inicio = lazy(() => import("../../pages/Inicio/Inicio"));
const Reservas = lazy(() => import("../../pages/Reservas/Reservas"));
const Revisar = lazy(() => import("../../pages/Revisar/Revisar"));
const Programacion = lazy(
  () => import("../../pages/Programacion/Programacion"),
);
const Cartadisp = lazy(() => import("../../pages/Menu/CartaDisp/Cartadisp"));
const EliminarCarta = lazy(
  () => import("../../pages/Menu/EliminarCarta/EliminarCarta"),
);
const Login = lazy(() => import("../../pages/Login/Login"));
const Register = lazy(() => import("../../pages/Registro/Register"));
const Actividades = lazy(() => import("../../pages/Actividades/Actividades"));
const Concursos = lazy(() => import("../../pages/Concursos/Concursos"));
const SuenaCurico = lazy(() => import("../../pages/SuenaCurico/SuenaCurico"));

const Allroutes = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-screen">
          <BarLoader color="#4f46e5" height={5} width={200} />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/quienes-somos" element={<Inicio />} />
          <Route
            path="/publicar"
            element={
              <ProtectedRoute>
                <Reservas />
              </ProtectedRoute>
            }
          />
          <Route path="/actividades" element={<Actividades />} />
          <Route
            path="/concursos"
            element={
              <ProtectedRoute>
                <Concursos />
              </ProtectedRoute>
            }
          />
          <Route path="/suena-curico" element={<SuenaCurico />} />
          <Route path="/" element={<Cartadisp />} />
          <Route path="/:permalink" element={<Cartadisp />} />
          <Route path="/revlamafe" element={<Revisar />} />
          <Route path="/programacion" element={<Programacion />} />
          <Route path="/programacion/:permalink" element={<Programacion />} />
          <Route path="/deleCard" element={<EliminarCarta />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Route>

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly={true}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route
            path="prohibited-words"
            element={<ProhibitedWordsManagement />}
          />
          <Route path="manual-approval" element={<ManualApprovalSettings />} />
          <Route
            path="contest-approval"
            element={<ContestApprovalSettings />}
          />
          <Route path="moderation" element={<ModerationPage />} />
          {/* Add nested admin routes here */}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Allroutes;
